require('./linkToPreferences.scss');

// @vendors
const React = require('react');

// @commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKButton } = require('components/commons/OKButton/OKButton');

const LinkToPreferences = () => {

    const preferencesButton = (
        <span>
            <OKButton
                modifier="link-ghost"
                to="/myprofile/settings"
            >
                <i className="icon-preferencias link-to-preferences__icon" />
            </OKButton>
        </span>
    );

    return (
        <OKTooltip
            content="myGlobalPosition-personalizeMyGlobalPosition"
            offset={[0, -15]}
            target={preferencesButton}
        />

    );
};

module.exports = LinkToPreferences;
